var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhystudyinusa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4867 5.83329C12.4867 8.74588 9.25557 11.7792 8.17057 12.716C8.06949 12.792 7.94645 12.8331 7.81999 12.8331C7.69352 12.8331 7.57048 12.792 7.4694 12.716C6.3844 11.7792 3.15332 8.74588 3.15332 5.83329C3.15332 4.59562 3.64499 3.40863 4.52016 2.53346C5.39533 1.65829 6.58231 1.16663 7.81999 1.16663C9.05766 1.16663 10.2446 1.65829 11.1198 2.53346C11.995 3.40863 12.4867 4.59562 12.4867 5.83329Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81982 7.58337C8.78632 7.58337 9.56982 6.79987 9.56982 5.83337C9.56982 4.86688 8.78632 4.08337 7.81982 4.08337C6.85333 4.08337 6.06982 4.86688 6.06982 5.83337C6.06982 6.79987 6.85333 7.58337 7.81982 7.58337Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhystudyinusa);
export default __webpack_public_path__ + "static/media/why study in usa.9b05cb3dcf25db068ce5af4f8b4aef6f.svg";
export { ForwardRef as ReactComponent };